function release() {
    // return "test";
    return "vdms";
}

export default release;
  